<template>
  <li
      v-if="isUserLoggedIn && isMounted"
      ref="dropdownRef"
      :class="['right setting list', { hover: isDropdownOpen }]"
      :style="{ height: isDropdownOpen ? heightRef + 'px' : undefined}"
  >
    <button class="user-menu-button">
      <span class="small circle active main">
        <template v-if="getUserShortName">{{ getUserShortName }}</template>
        <i class="icon-user" v-else></i>
      </span>
      <span class="text-bold">My Movoto</span>
      <a href="#" class="header-expand" role="button" aria-label="Expand List" @click="$emit('dropdownSelected', 'secondary-user-menu')">
        <i class="icon-angle-down"></i>
      </a>
    </button>
    <ul class="user-menu" v-if="loginMenu.length">
      <li
        v-for="(item, i) in userMenu"
        :key="`${item.title}-${i}`"
        :class="item.className"
      >
        <a :href="item.href">{{ item.title }} <span class="user-menu-count" v-if="item.count>0">{{ item.count }}</span></a>
      </li>
      <li class="split"></li>
      <li class="title" v-for="link in loginMenu" :key="link.text">
        <a v-if="link.href" :href="link.href" :rel="link.rel">{{ link.text }}</a>
        <a v-else-if="link.event" role="button" @click="$eventBus.$emit(link.event)">{{ link.text }}</a>
      </li>
      <li class="split"></li>
      <li class="hidden-xs hidden-sm">
        <button @click="$eventBus.$emit('eventbus-signout')"><i class="icon-circle-arrow"></i> {{ molang('header.SignOut') }}</button>
      </li>
    </ul>
  </li>
  <li v-else class="right sign-in-info">
    <div class="login-signup">
      <div class="hidden-xs hidden-sm flex">
        <button  class="btn secondary regular" @click="$eventBus.$emit('eventbus-signup', { intent: 'signin' })">Sign In</button>
        <button class="btn primary regular" type="button" @click="$eventBus.$emit('eventbus-signup')">Join For Free</button>
      </div>
      <div class="hidden-lg hidden-md sign-in-panel">
        <div class="text-bold f3">Become a member</div>
        <div class="f6">Keep all aspects of your home journey in one place—free!</div>
        <button class="btn primary medium" type="button" @click="$eventBus.$emit('eventbus-signup')">Join For Free</button>
        <div class="flex center f6">Already a member? <button  class="link text-bold" @click="$eventBus.$emit('eventbus-signup', { intent: 'signin' })">Sign in</button></div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'mvtHeaderMenuAuth',
  inject: ['$eventBus'],
  props: [
    'user',
    'activeDropdown'
  ],
  emits: ['dropdownSelected'],
  data() {
    return {
      heightRef: null,
      isMounted: false,
    };
  },
  computed: {
    ...mapGetters('glb', ['glb', 'getSavedSearchesCount', 'getSavedHomesCount']),
    isUserLoggedIn() {
      return !!this.user?.id;
    },
    isDropdownOpen() {
      return this.activeDropdown === 'secondary-user-menu';
    },
    claimedHomes() {
      return this.user?.id ? this.glb.claimedPropertiesList || [] : [];
    },
    loginMenu() {

      const { user, appUrl } = this.glb;

      if(user?.id) {

        const role = user.role;
        const hasRole = (roles) => roles.includes(role);

        const menu = [
          {
            text: this.molang('header.AgentHelp'),
            href: 'https://agenthelp.movoto.com/',
            validation: hasRole(['AGENT', 'COBROKER_AGENT'])
          },
          {
            text: "Notifications",
            href: `${appUrl}my-movoto/notifications/`,
            validation: hasRole(['AGENT', 'COBROKER_AGENT', 'NORMAL', 'MANAGEMENT'])
          },
          {
            text: "Account",
            href: `${appUrl}my-movoto/account/`,
            validation: hasRole(['AGENT', 'COBROKER_AGENT', 'NORMAL', 'MANAGEMENT'])
          },
          {
            text: this.molang('header.downloadApp'),
            href: `${appUrl}mobile/`,
            validation: true
          }
        ];

        return menu.filter(item => item.validation);

      }

      return [];

    },
    getUserShortName() {
      const names = (this.user.fullName || '').split(' ').filter(Boolean);
      return names.length ? (names[0][0] + (names[1]?.[0] || '')).toUpperCase() : '';
    },
    getUserName() {
      return this.user.fullName;
    },
    userMenu() {
      return [
        {
          title: 'My Home Search',
          href: `${this.glb.appUrl}my-movoto/my-home-search/`,
          className: 'title text-bold'
        },
        {
          title: 'Favorites',
          href: `${this.glb.appUrl}my-movoto/my-home-search/favorites/`,
          count: this.getSavedHomesCount > 0 ? this.getSavedHomesCount : undefined,
          className: ''
        },
        {
          title: "Saved searches",
          href: `${this.glb.appUrl}my-movoto/my-home-search/saved-searches/`,
          className: '',
          count: this.getSavedSearchesCount > 0 ? this.getSavedSearchesCount : undefined
        },
        {
          title: "Owned homes",
          href: `${this.glb.appUrl}homeowner/`,
          className: 'title text-bold'
        },
        ...this.claimedHomes.slice(0, 2).map((item) => ({
          title: item.geo?.address,
          href: `${this.glb.appUrl}my-movoto/my-homes/${item.propertyId}`,
          className: ''
        })),
        {
          title: 'My team',
          href: `${this.glb.appUrl}my-movoto/my-team/`,
          className: 'title text-bold'
        },
      ];
    },
  },
  watch: {
    async isDropdownOpen(val) {
      await this.$nextTick();
      if (this.$refs.dropdownRef) {
        this.heightRef = this.$refs.dropdownRef.scrollHeight + 1;
      }
    }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>